import { useAuth } from '@/store/auth.js'

// Pauses regular requests while a token refresh is already in progress.
// Refresh requests opt out through skipAuthWait to avoid waiting on themselves.
export async function waitForTokenRefresh(config) {
  const auth = useAuth()

  if (!config.skipAuthWait && auth.refreshPromise) {
    await auth.refreshPromise
  }

  return config
}
